const ZERO_REVIEW_LABEL = '0 Reviews';

export default class RatingsController {
    static verifyStarRating() {
        let wrapperCounter = 1;

        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                for (const node of mutation.addedNodes) {
                    if (
                        node.nodeType === Node.ELEMENT_NODE &&
                        node.classList.contains('yotpo-display-wrapper') &&
                        !node.id
                    ) {
                        const el = /** @type {HTMLElement} */ (node);

                        // assign a unique id
                        el.id = `wrapper-${wrapperCounter}`;

                        // if it already has a standalone-bottomline, just relabel its button
                        const standalone = el.querySelector('.standalone-bottomline');

                        if (standalone) {
                            const btn = standalone.querySelector('.yotpo-bottomline .write-review-btn-hidden');

                            if (btn) btn.textContent = ZERO_REVIEW_LABEL;
                        } else {
                            // otherwise append the whole bottomline markup
                            el.insertAdjacentHTML(
                                'beforeend',
                                `<div class="standalone-bottomline" data-source="default" tabindex="-1">
                                    <div class="yotpo-bottomline pull-left star-clickable" tabindex="0">
                                        <span class="yotpo-stars">
                                        <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>
                                        <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>
                                        <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>
                                        <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>
                                        <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>
                                        </span>
                                        <div class="yotpo-clr"></div>
                                    </div>
                                    <div class="yotpo-clr"></div>
                                </div>`
                            );
                        }

                        wrapperCounter += wrapperCounter;

                        // grab either the QA‐labels container or single‐label, and mirror it into .reviewCount
                        const labelsContainerEl = el.querySelector('.reviews-qa-labels-container');
                        const singleLabelEl = el.querySelector('.reviews-qa-label');
                        const labelsText = labelsContainerEl?.textContent?.trim() || '';
                        const singleText = singleLabelEl?.textContent?.trim() || '';
                        const reviewCounts = document.querySelectorAll('.reviewCount');

                        if (labelsText) {
                            reviewCounts.forEach((rc) => (rc.textContent = labelsText));
                        } else if (singleText) {
                            reviewCounts.forEach((rc) => (rc.textContent = singleText));
                        }
                    }
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
}
